// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.teep-report-page {
  width: 100%;
}

.teep-waterfall-wrap {
  position: relative;
  overflow: visible;
}
.teep-waterfall-wrap .apexcharts-menu-icon svg {
  fill: #475569;
}
.teep-waterfall-wrap .apexcharts-tooltip {
  border-radius: 6px !important;
  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.25) !important;
}
.teep-waterfall-wrap .apexcharts-tooltip.apexcharts-theme-dark {
  background: #1f2937 !important;
  border: 1px solid #374151 !important;
  color: #fff !important;
}
.teep-waterfall-wrap .apexcharts-title-text {
  font-weight: 600 !important;
}
.teep-waterfall-wrap .teep-wf-tip {
  padding: 6px 10px;
  text-align: left;
  line-height: 1.35;
}
.teep-waterfall-wrap .teep-wf-tip__cat {
  font-size: 11px;
  font-weight: 600;
  opacity: 0.85;
  margin-bottom: 4px;
  max-width: 220px;
}
.teep-waterfall-wrap .teep-wf-tip__val {
  font-size: 15px;
  font-weight: 700;
}
.teep-waterfall-wrap .teep-wf-tip__val span {
  font-size: 11px;
  font-weight: 500;
  opacity: 0.85;
  margin-left: 2px;
}
.teep-waterfall-wrap .teep-wf-tip__meta {
  margin-top: 8px;
  padding-top: 8px;
  border-top: 1px solid rgba(255, 255, 255, 0.12);
  font-size: 11px;
  font-weight: 600;
  opacity: 0.95;
  white-space: normal;
}
.teep-waterfall-wrap .teep-wf-lead {
  max-width: 72ch;
  line-height: 1.45;
}
.teep-waterfall-wrap .teep-wf-kpi-grid {
  display: grid;
  grid-template-columns: repeat(8, minmax(0, 1fr));
  gap: 6px 4px;
  margin-bottom: 10px;
  padding: 0 4px;
  min-height: 56px;
  align-items: start;
}
.teep-waterfall-wrap .teep-wf-chart-with-info {
  display: flex;
  align-items: flex-start;
  gap: 6px;
}
.teep-waterfall-wrap .teep-wf-summary-info-btn {
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 38px;
  height: 38px;
  margin-top: 2px;
  padding: 0;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  background: #fff;
  color: #475569;
  cursor: pointer;
  transition: background 0.15s ease, color 0.15s ease, border-color 0.15s ease;
}
.teep-waterfall-wrap .teep-wf-summary-info-btn:hover {
  background: #f1f5f9;
  color: #1e3a8a;
  border-color: #cbd5e1;
}
.teep-waterfall-wrap .teep-wf-summary-info-btn:focus-visible {
  outline: 2px solid #3b82f6;
  outline-offset: 2px;
}
.teep-waterfall-wrap .teep-wf-chart-canvas {
  flex: 1 1;
  min-width: 0;
}
.teep-waterfall-wrap .teep-wf-kpi-cell {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  text-align: center;
}
.teep-waterfall-wrap .teep-wf-kpi-pill {
  display: inline-block;
  max-width: 100%;
  padding: 3px 8px;
  border-radius: 8px;
  background: #0f172a;
  color: #f8fafc;
  font-size: 10px;
  font-weight: 700;
  line-height: 1.25;
  box-shadow: 0 1px 3px rgba(15, 23, 42, 0.2);
  word-break: break-word;
}
.teep-waterfall-wrap .teep-wf-summary-table {
  font-size: 12px;
}
.teep-waterfall-wrap .teep-wf-summary-table thead th {
  font-weight: 600;
  color: #475569;
  border-bottom-width: 1px;
}
.teep-waterfall-wrap .teep-wf-summary-table tbody td {
  vertical-align: top;
  border-color: #eef1f5;
}
.teep-waterfall-wrap .teep-wf-summary-table tbody tr:last-child td {
  border-bottom: none;
}

.teep-source-badge {
  margin-left: 6px;
  font-size: 10px;
  font-weight: 600;
  color: #16a34a;
  background: #dcfce7;
  padding: 1px 6px;
  border-radius: 10px;
  vertical-align: middle;
}

.teep-dot {
  display: inline-block;
  width: 9px;
  height: 9px;
  border-radius: 50%;
  flex-shrink: 0;
}

.teep-badge {
  display: inline-block;
  padding: 2px 10px;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 700;
}
.teep-badge.good {
  background: #dcfce7;
  color: #16a34a;
}
.teep-badge.medium {
  background: #fef9c3;
  color: #ca8a04;
}
.teep-badge.bad {
  background: #fee2e2;
  color: #dc2626;
}

.teep-oee-value {
  font-weight: 700;
  color: #8b5cf6;
}

.teep-stop-value {
  color: #ef4444;
}

.teep-part-tag {
  font-size: 11px;
  color: #6366f1;
  margin-top: 2px;
}

.teep-muted {
  color: #aab0bc;
}

.teep-code {
  color: #aab0bc;
  font-size: 11px;
  font-weight: 400;
  margin-left: 5px;
}`, "",{"version":3,"sources":["webpack://./src/views/pages/TEEP/TEEP.scss"],"names":[],"mappings":"AAEA;EACE,WAAA;AADF;;AAKA;EACE,kBAAA;EACA,iBAAA;AAFF;AAIE;EACE,aAAA;AAFJ;AAKE;EACE,6BAAA;EACA,qDAAA;AAHJ;AAME;EACE,8BAAA;EACA,oCAAA;EACA,sBAAA;AAJJ;AAOE;EACE,2BAAA;AALJ;AAQE;EACE,iBAAA;EACA,gBAAA;EACA,iBAAA;AANJ;AASE;EACE,eAAA;EACA,gBAAA;EACA,aAAA;EACA,kBAAA;EACA,gBAAA;AAPJ;AAUE;EACE,eAAA;EACA,gBAAA;AARJ;AAUI;EACE,eAAA;EACA,gBAAA;EACA,aAAA;EACA,gBAAA;AARN;AAYE;EACE,eAAA;EACA,gBAAA;EACA,+CAAA;EACA,eAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;AAVJ;AAaE;EACE,eAAA;EACA,iBAAA;AAXJ;AAcE;EACE,aAAA;EACA,gDAAA;EACA,YAAA;EACA,mBAAA;EACA,cAAA;EACA,gBAAA;EACA,kBAAA;AAZJ;AAeE;EACE,aAAA;EACA,uBAAA;EACA,QAAA;AAbJ;AAgBE;EACE,cAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,UAAA;EACA,yBAAA;EACA,mBAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;EACA,4EACE;AAfN;AAmBI;EACE,mBAAA;EACA,cAAA;EACA,qBAAA;AAjBN;AAoBI;EACE,0BAAA;EACA,mBAAA;AAlBN;AAsBE;EACE,SAAA;EACA,YAAA;AApBJ;AAuBE;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,QAAA;EACA,kBAAA;AArBJ;AAwBE;EACE,qBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,2CAAA;EACA,sBAAA;AAtBJ;AAyBE;EACE,eAAA;AAvBJ;AAyBI;EACE,gBAAA;EACA,cAAA;EACA,wBAAA;AAvBN;AA0BI;EACE,mBAAA;EACA,qBAAA;AAxBN;AA2BI;EACE,mBAAA;AAzBN;;AA8BA;EACE,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;EACA,gBAAA;EACA,mBAAA;EACA,sBAAA;AA3BF;;AA8BA;EACE,qBAAA;EACA,UAAA;EACA,WAAA;EACA,kBAAA;EACA,cAAA;AA3BF;;AA8BA;EACE,qBAAA;EACA,iBAAA;EACA,oBAAA;EACA,eAAA;EACA,gBAAA;AA3BF;AA6BE;EACE,mBAAA;EACA,cAAA;AA3BJ;AA8BE;EACE,mBAAA;EACA,cAAA;AA5BJ;AA+BE;EACE,mBAAA;EACA,cAAA;AA7BJ;;AAiCA;EACE,gBAAA;EACA,cAAA;AA9BF;;AAiCA;EACE,cAAA;AA9BF;;AAiCA;EACE,eAAA;EACA,cAAA;EACA,eAAA;AA9BF;;AAiCA;EACE,cAAA;AA9BF;;AAiCA;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;AA9BF","sourcesContent":["// TEEP-only helpers (reports layout comes from Reports.scss)\n\n.teep-report-page {\n  width: 100%;\n}\n\n// TEEP Şelalesi — match MES-style chart (dark tooltip, grid, toolbar)\n.teep-waterfall-wrap {\n  position: relative;\n  overflow: visible;\n\n  .apexcharts-menu-icon svg {\n    fill: #475569;\n  }\n\n  .apexcharts-tooltip {\n    border-radius: 6px !important;\n    box-shadow: 0 4px 14px rgba(0, 0, 0, 0.25) !important;\n  }\n\n  .apexcharts-tooltip.apexcharts-theme-dark {\n    background: #1f2937 !important;\n    border: 1px solid #374151 !important;\n    color: #fff !important;\n  }\n\n  .apexcharts-title-text {\n    font-weight: 600 !important;\n  }\n\n  .teep-wf-tip {\n    padding: 6px 10px;\n    text-align: left;\n    line-height: 1.35;\n  }\n\n  .teep-wf-tip__cat {\n    font-size: 11px;\n    font-weight: 600;\n    opacity: 0.85;\n    margin-bottom: 4px;\n    max-width: 220px;\n  }\n\n  .teep-wf-tip__val {\n    font-size: 15px;\n    font-weight: 700;\n\n    span {\n      font-size: 11px;\n      font-weight: 500;\n      opacity: 0.85;\n      margin-left: 2px;\n    }\n  }\n\n  .teep-wf-tip__meta {\n    margin-top: 8px;\n    padding-top: 8px;\n    border-top: 1px solid rgba(255, 255, 255, 0.12);\n    font-size: 11px;\n    font-weight: 600;\n    opacity: 0.95;\n    white-space: normal;\n  }\n\n  .teep-wf-lead {\n    max-width: 72ch;\n    line-height: 1.45;\n  }\n\n  .teep-wf-kpi-grid {\n    display: grid;\n    grid-template-columns: repeat(8, minmax(0, 1fr));\n    gap: 6px 4px;\n    margin-bottom: 10px;\n    padding: 0 4px;\n    min-height: 56px;\n    align-items: start;\n  }\n\n  .teep-wf-chart-with-info {\n    display: flex;\n    align-items: flex-start;\n    gap: 6px;\n  }\n\n  .teep-wf-summary-info-btn {\n    flex-shrink: 0;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    width: 38px;\n    height: 38px;\n    margin-top: 2px;\n    padding: 0;\n    border: 1px solid #e2e8f0;\n    border-radius: 10px;\n    background: #fff;\n    color: #475569;\n    cursor: pointer;\n    transition:\n      background 0.15s ease,\n      color 0.15s ease,\n      border-color 0.15s ease;\n\n    &:hover {\n      background: #f1f5f9;\n      color: #1e3a8a;\n      border-color: #cbd5e1;\n    }\n\n    &:focus-visible {\n      outline: 2px solid #3b82f6;\n      outline-offset: 2px;\n    }\n  }\n\n  .teep-wf-chart-canvas {\n    flex: 1;\n    min-width: 0;\n  }\n\n  .teep-wf-kpi-cell {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: 4px;\n    text-align: center;\n  }\n\n  .teep-wf-kpi-pill {\n    display: inline-block;\n    max-width: 100%;\n    padding: 3px 8px;\n    border-radius: 8px;\n    background: #0f172a;\n    color: #f8fafc;\n    font-size: 10px;\n    font-weight: 700;\n    line-height: 1.25;\n    box-shadow: 0 1px 3px rgba(15, 23, 42, 0.2);\n    word-break: break-word;\n  }\n\n  .teep-wf-summary-table {\n    font-size: 12px;\n\n    thead th {\n      font-weight: 600;\n      color: #475569;\n      border-bottom-width: 1px;\n    }\n\n    tbody td {\n      vertical-align: top;\n      border-color: #eef1f5;\n    }\n\n    tbody tr:last-child td {\n      border-bottom: none;\n    }\n  }\n}\n\n.teep-source-badge {\n  margin-left: 6px;\n  font-size: 10px;\n  font-weight: 600;\n  color: #16a34a;\n  background: #dcfce7;\n  padding: 1px 6px;\n  border-radius: 10px;\n  vertical-align: middle;\n}\n\n.teep-dot {\n  display: inline-block;\n  width: 9px;\n  height: 9px;\n  border-radius: 50%;\n  flex-shrink: 0;\n}\n\n.teep-badge {\n  display: inline-block;\n  padding: 2px 10px;\n  border-radius: 999px;\n  font-size: 12px;\n  font-weight: 700;\n\n  &.good {\n    background: #dcfce7;\n    color: #16a34a;\n  }\n\n  &.medium {\n    background: #fef9c3;\n    color: #ca8a04;\n  }\n\n  &.bad {\n    background: #fee2e2;\n    color: #dc2626;\n  }\n}\n\n.teep-oee-value {\n  font-weight: 700;\n  color: #8b5cf6;\n}\n\n.teep-stop-value {\n  color: #ef4444;\n}\n\n.teep-part-tag {\n  font-size: 11px;\n  color: #6366f1;\n  margin-top: 2px;\n}\n\n.teep-muted {\n  color: #aab0bc;\n}\n\n.teep-code {\n  color: #aab0bc;\n  font-size: 11px;\n  font-weight: 400;\n  margin-left: 5px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
